 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"992d5974743b5c56cb39e2c92a326524b77ed665","2":"0096d4f1decaf980f4e2bb9595d93572bfa05b1a","3":"389f9b18d93a7752a74e3393f5e24e894fa5861c","4":"11b9469b716b466e3ea2759d7865aeba55ec4f5b","5":"8a35ecd30067bd16988ef335e59862d4ca90a77a","7":"PuxRepeaterParts-ArticlePart","8":"PuxRepeaterParts-CaseStudyPart","9":"PuxRepeaterParts-FaqPart","10":"PuxRepeaterParts-FunctionPart","11":"PuxRepeaterParts-KnowledgeBaseArticlePart","12":"PuxRepeaterParts-NewsPart","13":"PuxRepeaterParts-PartnerPart","14":"PuxRepeaterParts-TestimonialPart","15":"PuxRepeaterParts-VideoTutorialPart","16":"PuxRepeaterfilters-PartnerFilter","17":"PuxRepeaterfilters-VideoTutorialFilter","18":"Shared-components-EasySoftwareSideCard-EasySoftwareSideCardCustom","19":"Shared-components-EasySoftwareSideCard-EasySoftwareSideCardNavigation","20":"Shared-components-EasySoftwareSideCard-EasySoftwareSideCardNewsletter","21":"Shared-components-EasySoftwareSideCard-EasySoftwareSideCardTrial","22":"Shared-components-PuxLightboxGallery-PuxLightboxGallery","23":"Shared-components-widgets-WidgetEasySoftwareBenefits","24":"Shared-components-widgets-WidgetEasySoftwareCards","25":"Shared-components-widgets-WidgetEasySoftwareCaseStudies","26":"Shared-components-widgets-WidgetEasySoftwareEmbeddedCodeContainer","27":"Shared-components-widgets-WidgetEasySoftwareFeatures","28":"Shared-components-widgets-WidgetEasySoftwareIconBar","29":"Shared-components-widgets-WidgetEasySoftwareModules","30":"Shared-components-widgets-WidgetEasySoftwareNavigator","31":"Shared-components-widgets-WidgetEasySoftwareReviews","32":"Shared-components-widgets-WidgetEasySoftwareSearchBanner","33":"Shared-components-widgets-WidgetEasySoftwareSolutions","34":"Shared-components-widgets-WidgetEasySoftwareTable","35":"Shared-components-widgets-WidgetEasySoftwareTestimonials","36":"Shared-components-widgets-WidgetEasySoftwareTimeline","37":"Shared-components-widgets-WidgetEasySoftwareVideoBanner","38":"Shared-components-widgets-WidgetPuxGallery","39":"Shared-components-widgets-WidgetPuxGalleryWrapper","40":"Shared-components-widgets-WidgetPuxImageContent","41":"Shared-components-widgets-WidgetPuxNumbersContainer","42":"Shared-components-widgets-WidgetPuxRepeater","43":"Shared-components-widgets-WidgetPuxVideoContainer","44":"Shared-components-widgets-WidgetPuxWysiwyg","46":"component---src-pages-404-tsx","47":"component---src-pages-preview-tsx","48":"component---src-pages-styleguide-tsx","49":"component---src-templates-article-article-page-tsx","50":"component---src-templates-case-study-case-study-detail-tsx","51":"component---src-templates-category-category-page-tsx","52":"component---src-templates-easy-software-page-tsx","53":"component---src-templates-faq-faq-detail-tsx","54":"component---src-templates-function-function-detail-tsx","55":"component---src-templates-home-page-pux-home-page-tsx","56":"component---src-templates-knowledge-base-knowledge-base-article-tsx","57":"component---src-templates-knowledge-base-knowledge-base-category-tsx","58":"component---src-templates-knowledge-base-knowledge-base-tsx","59":"component---src-templates-landing-landing-page-tsx","60":"component---src-templates-news-news-detail-tsx","61":"component---src-templates-pricing-pricing-page-tsx","63":"material-ui-core-Tooltip"}[chunkId]||chunkId) + "-" + {"0":"5ba8a4210d598af75b53","1":"9248303d846834d4ea1f","2":"fdfc3a61396e06ab9bb8","3":"95344c3d4160e18c157d","4":"b3e941e21e17be51f9f2","5":"5de65097c7f712177ada","7":"ce833c15688199abbf8f","8":"fcee55ef16ab9c30d543","9":"edfbd7a5a68ad489d900","10":"6812f9b9cc1c9986fa15","11":"d7a3e635ee8ea37bcb8e","12":"771a117a238e701aa6b2","13":"414480ff712622dab939","14":"920cdb084892928b33f5","15":"42cf3d2abf437e37acc7","16":"a351b500e9d2989ac8db","17":"723ac655eaf31343a3ae","18":"d294cba086b204531b30","19":"621074b5c0a16450c390","20":"def24930254d08cd21cd","21":"e16570e43c511ad1df9c","22":"608a9cbec47071e67c64","23":"a5cf161f68f18389fd82","24":"1cb103a4633f19110baf","25":"7257e855262e688b102a","26":"d4b6f6c1b5d9c7701270","27":"b0b3894c031b127db352","28":"822a5986dab1daf668d5","29":"cd0d6ba70c1abc47568b","30":"17a910a9db3a840a6780","31":"f6baa89dc37b504cb76a","32":"53850cf2ade991d56c15","33":"d890a86c114f898ea3e8","34":"c0c85cd0e3c957a4b714","35":"0dd5e88bf5728f4fae07","36":"62cf0bf889fd80417023","37":"ddd73ff7ba0ef3137c2e","38":"f8bab9310b6cd29631a0","39":"27306f0a61c280da5bf6","40":"5a5fe5909441362fcd20","41":"7355e9b2e961cfb1ac45","42":"b7588c6403ac74149852","43":"0a73266e970e3189d51a","44":"ebe29fb62248b6285bd3","46":"25e5b96062191a662ced","47":"9f795cd85aab95996b69","48":"a8fb445e3463cb67f86e","49":"57ced5834311b1401d15","50":"4e5e7c30dd8039e55ad3","51":"45b4b0f2c7240bab9f9b","52":"d642a88db3f24d4a146f","53":"3621d851a9b8ccd71163","54":"e296ee1fceeadca1266c","55":"e54946f742031bdaf5c1","56":"59a8bd56f36158a9dcc1","57":"33153fe033385ed1519b","58":"ae529a238d898a72fb26","59":"72ac60a196f44258479b","60":"e5506244deeefdbe34c1","61":"4c163dd740f3c74df112","63":"0d0f615af05b829dabf5","66":"c870a6b823720b2b4c9e","67":"73d574a0f0e663b7c74e","68":"462b9297e587f3dcc879","69":"08567f929cf004ed5cec","70":"45f6976fd37332bb6f66","71":"d69eb344974bc628c391","72":"6b7757ef3bda6c9d300e","73":"ad25e009942a43839556","74":"837a286063170eee1ddc","75":"1b9a6cff1113ff1cc396","76":"2f026e6c8302b625f80b","77":"49f05694bff1e9a0528c","78":"c649f3ac2910036452b4","79":"fe527a8754c3384368b5","80":"823085e0e668283ab11c","81":"5bdf466a9bc3b6266cda","82":"9ea82e0509b8677c2448","83":"71c53e19d9d8be43950c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"46":1,"47":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"992d5974743b5c56cb39e2c92a326524b77ed665","2":"0096d4f1decaf980f4e2bb9595d93572bfa05b1a","3":"389f9b18d93a7752a74e3393f5e24e894fa5861c","4":"11b9469b716b466e3ea2759d7865aeba55ec4f5b","5":"8a35ecd30067bd16988ef335e59862d4ca90a77a","7":"PuxRepeaterParts-ArticlePart","8":"PuxRepeaterParts-CaseStudyPart","9":"PuxRepeaterParts-FaqPart","10":"PuxRepeaterParts-FunctionPart","11":"PuxRepeaterParts-KnowledgeBaseArticlePart","12":"PuxRepeaterParts-NewsPart","13":"PuxRepeaterParts-PartnerPart","14":"PuxRepeaterParts-TestimonialPart","15":"PuxRepeaterParts-VideoTutorialPart","16":"PuxRepeaterfilters-PartnerFilter","17":"PuxRepeaterfilters-VideoTutorialFilter","18":"Shared-components-EasySoftwareSideCard-EasySoftwareSideCardCustom","19":"Shared-components-EasySoftwareSideCard-EasySoftwareSideCardNavigation","20":"Shared-components-EasySoftwareSideCard-EasySoftwareSideCardNewsletter","21":"Shared-components-EasySoftwareSideCard-EasySoftwareSideCardTrial","22":"Shared-components-PuxLightboxGallery-PuxLightboxGallery","23":"Shared-components-widgets-WidgetEasySoftwareBenefits","24":"Shared-components-widgets-WidgetEasySoftwareCards","25":"Shared-components-widgets-WidgetEasySoftwareCaseStudies","26":"Shared-components-widgets-WidgetEasySoftwareEmbeddedCodeContainer","27":"Shared-components-widgets-WidgetEasySoftwareFeatures","28":"Shared-components-widgets-WidgetEasySoftwareIconBar","29":"Shared-components-widgets-WidgetEasySoftwareModules","30":"Shared-components-widgets-WidgetEasySoftwareNavigator","31":"Shared-components-widgets-WidgetEasySoftwareReviews","32":"Shared-components-widgets-WidgetEasySoftwareSearchBanner","33":"Shared-components-widgets-WidgetEasySoftwareSolutions","34":"Shared-components-widgets-WidgetEasySoftwareTable","35":"Shared-components-widgets-WidgetEasySoftwareTestimonials","36":"Shared-components-widgets-WidgetEasySoftwareTimeline","37":"Shared-components-widgets-WidgetEasySoftwareVideoBanner","38":"Shared-components-widgets-WidgetPuxGallery","39":"Shared-components-widgets-WidgetPuxGalleryWrapper","40":"Shared-components-widgets-WidgetPuxImageContent","41":"Shared-components-widgets-WidgetPuxNumbersContainer","42":"Shared-components-widgets-WidgetPuxRepeater","43":"Shared-components-widgets-WidgetPuxVideoContainer","44":"Shared-components-widgets-WidgetPuxWysiwyg","46":"component---src-pages-404-tsx","47":"component---src-pages-preview-tsx","48":"component---src-pages-styleguide-tsx","49":"component---src-templates-article-article-page-tsx","50":"component---src-templates-case-study-case-study-detail-tsx","51":"component---src-templates-category-category-page-tsx","52":"component---src-templates-easy-software-page-tsx","53":"component---src-templates-faq-faq-detail-tsx","54":"component---src-templates-function-function-detail-tsx","55":"component---src-templates-home-page-pux-home-page-tsx","56":"component---src-templates-knowledge-base-knowledge-base-article-tsx","57":"component---src-templates-knowledge-base-knowledge-base-category-tsx","58":"component---src-templates-knowledge-base-knowledge-base-tsx","59":"component---src-templates-landing-landing-page-tsx","60":"component---src-templates-news-news-detail-tsx","61":"component---src-templates-pricing-pricing-page-tsx","63":"material-ui-core-Tooltip"}[chunkId]||chunkId) + "." + {"0":"397788d6a40d249e7b44","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","7":"f3c0bb080402b03a6a8c","8":"667e39c20605413bf6f4","9":"3fcc6a832ec6cab69e2b","10":"4b6cbfdd1e589d5c4302","11":"fefb488e9da1532ebb5b","12":"f2ce0a3a83afcd4d1536","13":"666693465504a4968e92","14":"1e0df26293d48cea01b3","15":"a3ca4f0d3113df069a19","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"fe364fa89ac6b2440ecf","19":"768859b8cdf82817a48a","20":"1cbf011a060273a75491","21":"fe364fa89ac6b2440ecf","22":"a4bc407071c9754613cd","23":"4c367b162b11150dec13","24":"20bd30fea8a9dcfaf265","25":"50d4b4bb99b3027bba0f","26":"0e4338761429b4eb16ac","27":"e0d59265c38d99bab3c4","28":"db1950ad1d15e82af9ff","29":"62d3cd42a905bd8abf7f","30":"cb2d0991c04b8d9f17ad","31":"443bd61e80adaa668d36","32":"6fed85834d6765b07a79","33":"976fe282226dea7b20f7","34":"97f89dc1d7ea636a3958","35":"2e53d0736e0198e5036b","36":"1f6ea21275915b4ebac6","37":"214ad928f9e2f6614c20","38":"fcd31716624410ee74b0","39":"fcd31716624410ee74b0","40":"9a5de95394ccdeb9be43","41":"6637d7ed45533ac6235d","42":"ffb09d70179b05e58ff5","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","46":"b55fc01a43264c9ff270","47":"035bdc3238904a6926bc","48":"31d6cfe0d16ae931b73c","49":"bfba9889388ea2d2930d","50":"41f11fa4274cc3dbd950","51":"37544fac4a4d8aa8ff50","52":"66c4db412550ceaba8b4","53":"8ad2cd32ddfa8d141e41","54":"1531af044bb7fa07d5ca","55":"66c4db412550ceaba8b4","56":"57593503c64abcc38574","57":"d351d39f1e3d16851ba1","58":"2518bba0d7ccacb3607a","59":"fb900af1b5c13ed2fdf5","60":"23e93bb47cc1db853c86","61":"5a3eda62322148ff7f4f","63":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
